import { brandApi } from '../lib/axios';
import { 
  ReviewPromptStatus, 
  UpdateReviewPrompt, 
  CheckReviewEligibility 
} from '../types/review-prompt';

class ReviewPromptService {
  async getReviewPromptStatus(): Promise<ReviewPromptStatus> {
    const response = await brandApi.get<ReviewPromptStatus>(
      '/brand/review-prompt/status'
    );
    return response.data;
  }

  async updateReviewPromptStatus(
    data: UpdateReviewPrompt
  ): Promise<ReviewPromptStatus> {
    const response = await brandApi.post<ReviewPromptStatus>(
      '/brand/review-prompt/update',
      data
    );
    return response.data;
  }

  async checkReviewEligibility(): Promise<CheckReviewEligibility> {
    const response = await brandApi.get<CheckReviewEligibility>(
      '/brand/review-prompt/check-eligibility'
    );
    return response.data;
  }
}

export const reviewPromptService = new ReviewPromptService();


